import { render, staticRenderFns } from "./system-update-icon.vue?vue&type=template&id=6883346a"
import script from "./system-update-icon.vue?vue&type=script&lang=js"
export * from "./system-update-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6883346a')) {
      api.createRecord('6883346a', component.options)
    } else {
      api.reload('6883346a', component.options)
    }
    module.hot.accept("./system-update-icon.vue?vue&type=template&id=6883346a", function () {
      api.rerender('6883346a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/notifications/system-update-icon.vue"
export default component.exports